import { render, staticRenderFns } from "./Login-v1.vue?vue&type=template&id=24cc75e8"
import script from "./Login-v1.vue?vue&type=script&lang=js"
export * from "./Login-v1.vue?vue&type=script&lang=js"
import style0 from "./Login-v1.vue?vue&type=style&index=0&id=24cc75e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports